import {createStyles, Theme} from "@material-ui/core";
import {errorColor, styleColors, typography} from "src/main.style";

export const NewPackingListItemRowStyle = (theme: Theme) => createStyles({
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    minHeight: '50px',
    padding: '0px 23px',
    boxSizing: 'border-box',
  },
  addIcon: {
    width: '22px',
    height: '22px',
    color: styleColors.greyMedium2,
  },
  input: {
    flex: 1,
    minWidth: 0,
    ...typography.input,
    fontSize: '0.9375rem',
    color: theme.palette.common.black,
    backgroundColor: 'transparent',
    borderWidth: 0,
    outline: 'none',
    padding: '10px 0px',
    '&::placeholder': {
      ...typography.input,
      fontSize: '0.9375rem',
      color: theme.palette.common.grey,
    },
  },
  // Lines up with the input, past the 22px icon and 8px gap.
  hint: {
    padding: '0px 23px 10px 53px',
    fontSize: '12px',
    color: errorColor,
  },
});



// WEBPACK FOOTER //
// ./src/components/next-handover/NewPackingListItemRow.style.ts